import { useEffect, useState } from "react";
import {
  ITranslitingTooltipRef,
  ITranslitingTooltipProps,
} from "./TranslitingTooltip.props";

interface ITranslitingTooltipControl {
  readonly open: boolean;
}

export const useTranslitingTooltipControl = (
  props: ITranslitingTooltipProps
): ITranslitingTooltipControl => {
  const [open, setOpen] = useState<boolean>(false);
  const onOpen = () => setOpen(true);

  const ref: ITranslitingTooltipRef = { onOpen };

  useEffect(() => {
    props.controlledRef(ref);
  }, [props.controlledRef]);

  useEffect(() => {
    const t = setTimeout(() => setOpen(false), 2000);
    return () => clearInterval(t);
  }, [open]);

  return {
    open,
  };
};
